import { render, staticRenderFns } from "./SectionFAQ.vue?vue&type=template&id=111ea1ce&"
import script from "./SectionFAQ.vue?vue&type=script&lang=js&"
export * from "./SectionFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports